import React, { useState } from "react";
import './FieldsMap.scss';

import MapMarker from './MapMarker';
import {useSelector} from "react-redux";
import MapView from "./Maps/MapView";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const MapWithPopups = props => {
    const { zoom, center, markers, handleLinkClick, mapType } = props;
    // const [displayInfo, setDisplayInfo] = useState(false);
    // const [selectedMarker, selectMarker] = useState({});
    const { t } = useSelector(selector);

    const renderFieldInfo = (selectedMarker) => (
        <div
            className='fieldsMapMarkerSelected'
            // onClick={() => {setDisplayInfo(false); selectMarker({});}}
        >
            <div className='fieldsMapMarkerSelectedTop'>{t.gettext('Average Temperature')}</div>
            <div className='fieldsMapMarkerSelectedMiddle'>
                {Math.round(selectedMarker.averageTemperature)}
                {selectedMarker.averageTemperature !== 'n/a' ? ' c' : ''}
                {selectedMarker.sensors &&
                    <div
                        className='fieldsMapMarkerSensorsLink'
                        onClick={() => handleLinkClick(selectedMarker.id)}
                    >
                        {t.gettext('Sensors') + ': ' + selectedMarker.sensors.length}
                    </div>
                }
            </div>
            <div className='fieldsMapMarkerSelectedBottom'>
                <MapMarker
                    color={selectedMarker.color}
                    width='17'
                    height='26'
                />
                <span>{selectedMarker.name}</span>
            </div>
        </div>
    );

    const renderSensorInfo = (selectedMarker) => (
        <div
            className='sensorsMapMarkerSelected'
        >
            <div className='sensorsMapMarkerSelectedTop'>{t.gettext('Temperature')}</div>
            <div className='sensorsMapMarkerSelectedMiddle'>
                {Math.round(selectedMarker.temperature)}
                {selectedMarker.temperature !== 'n/a' ? ' c' : ''}
            </div>
            <div className='sensorsMapMarkerSelectedTop'>{t.gettext('Humidity')}</div>
            <div className='sensorsMapMarkerSelectedMiddle'>
                {Math.round(selectedMarker.humidity)}
                {selectedMarker.humidity !== 'n/a' ? ' %' : ''}
            </div>
            <div className='sensorsMapMarkerSelectedBottom'>
                <MapMarker
                    color={selectedMarker.color}
                    width='17'
                    height='26'
                />
                <span>{selectedMarker.name}</span>
            </div>
        </div>
    )

    return (
        <MapView
            zoom={zoom}
            center={center}
            popupMarkers={markers}
            popupContainer={mapType === 'fields' ? renderFieldInfo : renderSensorInfo}
            // handleLinkClick={handleShowSensors}
        />
    );
}

export default MapWithPopups;
